'use strict';

angular.module('mandaeApp')
  .factory('Cliente', function Cliente($rootScope, $q, $http, ClienteResource, localStorageService, Pedido, URLAPICLIENTE) {

    var ultimoEndereco = {};
    var ultimoEnderecoEtiqueta = {};

    var setUltimoEndereco = function(novoUltimoEndereco) {
      localStorageService.set('ultimoEndereco', novoUltimoEndereco);
      ultimoEndereco = novoUltimoEndereco;
    };

    var setUltimoEnderecoEtiqueta = function(novoUltimoEnderecoEtiqueta) {
      localStorageService.set('ultimoEnderecoEtiqueta', novoUltimoEnderecoEtiqueta);
      ultimoEnderecoEtiqueta = novoUltimoEnderecoEtiqueta;
    };

    return {

      /**
       * Retorna endereço por cep.
       *
       * @param  {Object}   cep     - cep
       * @param  {Function} callback - optional
       * @return {Promise}
       */
      buscarUltimosEnderecos: function(customerId, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.ultimosEnderecos({ customerId: customerId }).$promise
          .then(function(data) {
            setUltimoEndereco(data[0] ? data[0] : null);
            setUltimoEnderecoEtiqueta(data[1] ? data[1] : null);

            deferred.resolve(data);
            return cb(data);
          })
          .catch(function(err) {
            deferred.reject(err);
            return cb(err);
          }.bind(this));

        return deferred.promise;
      },

      getUltimoEndereco: function() {
        var ultimoEnderecoLS = localStorageService.get('ultimoEndereco');
        if ((ultimoEndereco == null || ultimoEndereco.cep == null) && ultimoEnderecoLS != null && ultimoEnderecoLS.cep != null) {
          ultimoEndereco = ultimoEnderecoLS;
        }

        return ultimoEndereco;
      },

      getUltimoEnderecoEtiqueta: function() {
        var ultimoEnderecoEtiquetaLS = localStorageService.get('ultimoEnderecoEtiqueta');
        if ((ultimoEnderecoEtiqueta == null || ultimoEnderecoEtiqueta.cep == null) && ultimoEnderecoEtiquetaLS != null && ultimoEnderecoEtiquetaLS.cep != null) {
          ultimoEnderecoEtiqueta = ultimoEnderecoEtiquetaLS;
        }

        return ultimoEnderecoEtiqueta;
      },

      getTelefone: function(cliente) {
        if (cliente && cliente.telefones && cliente.telefones[0]) {
          return cliente.telefones[0].ddd + cliente.telefones[0].numero;
        } else {
          return '';
        }
      },

      atualizar: function(cliente, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.save({ customerId: cliente.id }, cliente).$promise
          .then(function(novoCliente) {
            Pedido.getPedido().cliente = novoCliente;

            if (novoCliente.codigoCupom) {
              localStorageService.set('codigoCupom', novoCliente.codigoCupom);
            } else {
              localStorageService.remove('codigoCupom');
            }

            deferred.resolve(novoCliente);
            return cb(novoCliente);
          })
          .catch(function(err) {
            deferred.reject(err);
            return cb(err);
          }.bind(this));

        return deferred.promise;
      },

      atualizarEnderecoAtivo: function(enderecos, callback) {
        for (var i = 0; i < enderecos.length; i++) {
          if (enderecos[i].ativo) {
            setUltimoEndereco(enderecos[i]);
            if (enderecos[i] && enderecos[i].etiqueta) {
              setUltimoEnderecoEtiqueta(enderecos[i].etiqueta);
            } else {
              setUltimoEnderecoEtiqueta(null);
            }
          }
        }
      },

      criarContato: function(clienteId, contato, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.criarContato({ clienteId: clienteId }, contato)
          .$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          })
          .catch(function(err) {
            deferred.reject(err);
            return cb(err);
          }.bind(this));

        return deferred.promise;
      },

      editarContato: function(clienteId, contatoId, contato, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.editarContato({
          clienteId: clienteId,
          contatoId: contatoId
        }, contato)
          .$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          })
          .catch(function(err) {
            deferred.reject(err);
            return cb(err);
          }.bind(this));

        return deferred.promise;
      },

      getContatos: function(clienteId, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.getContatos({ clienteId: clienteId })
          .$promise
          .then(function(contatos) {
            deferred.resolve(contatos);
            return cb(contatos);
          })
          .catch(function(err) {
            deferred.reject(err);
            return cb(err);
          }.bind(this));

        return deferred.promise;
      },

      removeContato: function(clienteId, contatoId, callback) {
        var cb = callback || angular.noop;
        var deferred = $q.defer();

        ClienteResource.removeContato({
          clienteId: clienteId,
          contatoId: contatoId
        })
          .$promise
          .then(function(data) {
            deferred.resolve(data);
            return cb(data);
          })
          .catch(function(err) {
            deferred.reject(err);
            return cb(err);
          }.bind(this));

        return deferred.promise;
      },

      arquivoFatura: function(faturaId, formato, callback) {
        return $http.get(URLAPICLIENTE + '/v1/faturas/' + faturaId + '/arquivos/' + formato, {responseType: "arraybuffer"});
      },

      getPrefixos: function (clienteId) {
        return ClienteResource.getPrefixos({ clienteId: clienteId }).$promise;
      }
    }

  });
